import styled from '@emotion/styled'

export const SCard = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem;
  border: 1px solid var(--c-blue100);
  border-radius: 2px;
`

export const SCardTitleRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 0.75rem;

  & svg {
    width: 1.5rem;
    height: 1.5rem;
    margin-right: 1rem;

    & path {
      stroke: var(--c-gray100);
      stroke-width: 2px;
    }
  }
`
